import { PriceApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { GetLocationsRequest } from '@/types/http-payload/location';
import { TableState } from '@tanstack/react-table';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { GetPriceListRequest, GetPriceListResponse, PriceFormDataRequest } from '@/types/http-payload/price';
import { Price, PriceDetails } from '@/types/price';

export default class PriceStore extends BaseStore {
    priceList: Price[] = [];
    priceEUList: any[] = [];
    priceDetail: PriceDetails | null = null;
    api: PriceApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            priceList: observable,
            priceDetail: observable,
            priceEUList: observable,
            getPriceList: flow.bound,
            getPriceListEnduser: flow.bound,
            // getPriceListEnduserCheck: flow.bound,
            deletePrice: flow.bound,
            createPrice: flow.bound,
            getPriceDetail: flow.bound,
            updatePrice: flow.bound
        });
        this.api = new PriceApi();
    }

    *getPriceList(searchParams: GetLocationsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<GetPriceListResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getPriceList, payload);
            if (res.ok) {
                this.priceList = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
            }
        } catch (error) {
        }
    }

    *getPriceListEnduser(request: GetPriceListRequest) {
        try {
            const res: ResponseData<PriceDetails[]> = yield this.rootStore.apiStore.call(this.api, this.api.getPriceListEnduser, request);
            if (res.ok) {
                this.priceEUList = res.data;
                return res.data;
            }
        } catch (error) {
        }
    }

    // *getPriceListEnduserCheck(request: GetPriceListRequest) {
    //     try {
    //         const res: ResponseData<PriceDetails[]> = yield this.rootStore.apiStore.call(this.api, this.api.getPriceListEnduser, request);
    //         if (res.ok) {
    //             return true;
    //         }
    //     } catch (error) {
    //     }
    // }

    *getPriceDetail(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getPriceDetail, id);
            if (res?.ok) {
                this.priceDetail = res.data;
                return res.data;
            }
        } catch (error) {
        }
    }

    *deletePrice(id: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deletePrice, id);
            if (res?.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *createPrice(payload: PriceFormDataRequest) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.createPrice, payload);
            if (res?.ok) {
                return true;
            }
        } catch (error) {
        }
    }

    *updatePrice(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updatePrice, payload);
            if (res?.ok) {
                return true;
            }
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.priceList = [];
        this.priceDetail = null;
    }

    cleanEu(): void {
        this.priceEUList = [];
    }
}
